__turbopack_context__.v({
  "eyebrow": "SoftwareDevelopmentServicesCardSection-module__jW4d4G__eyebrow",
  "heading": "SoftwareDevelopmentServicesCardSection-module__jW4d4G__heading",
  "section": "SoftwareDevelopmentServicesCardSection-module__jW4d4G__section",
  "title": "SoftwareDevelopmentServicesCardSection-module__jW4d4G__title",
});
